import styled from "styled-components";

export const RowButton = styled.button<{ $last?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 2px;
  border: none;
  border-bottom: ${(p) => (p.$last ? "none" : `1px solid ${p.theme.tokens.colors.softBg}`)};
  background: none;
  cursor: pointer;
  text-align: left;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const RowIcon = styled.span<{ $selected?: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: ${(p) => (p.$selected ? p.theme.tokens.colors.softTeal : p.theme.tokens.colors.bg)};
  color: ${(p) => (p.$selected ? p.theme.tokens.colors.teal : "#9AA8A3")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const RowTitle = styled.div`
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const RowSub = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 1px;
`;

export const Check = styled.span<{ $selected?: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 999px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(p) => (p.$selected ? "none" : "2px solid #D5DEDA")};
  background: ${(p) => (p.$selected ? p.theme.tokens.gradients.accent : p.theme.tokens.colors.surface)};
`;
